<div class="table-page cctv-page-header">
  <header class="header">
    <div class="title-row">
      <button class="back" type="button" routerLink="/" aria-label="بازگشت">
        <i class="fa fa-arrow-right" aria-hidden="true"></i>
      </button>
      <h1 class="title">نظارت تصویری - دوربین‌ها</h1>
    </div>
  </header>
</div>

<main class="cctv-page">
  <section [formGroup]="mdl_Request" class="row gx-0 gy-0 p-2">
    <aside class="col-xxl-3 col-md-4 col-12 p-1" aria-label="انتخاب خودرو و دوربین">
      <div class="vehicle-panel">
        <div class="vehicle-panel__heading">
          <h2>خودروها</h2>
          <span class="vehicle-count">{{ lst_Car.length | faNum }} خودرو</span>
        </div>
        <div class="stream-tabs" role="group" aria-label="فیلتر خودروها">
          <button type="button" [class.is-active]="!isLiveStreaming" [attr.aria-pressed]="!isLiveStreaming"
            [disabled]="listLoading" (click)="vehicleSearch.value = ''; getAllCar(false)">همه خودروها</button>
          <button type="button" [class.is-active]="isLiveStreaming" [attr.aria-pressed]="isLiveStreaming"
            [disabled]="listLoading" (click)="vehicleSearch.value = ''; getAllCar(true)">فعال‌ها</button>
        </div>
        <div class="vehicle-filters">
          <div class="vehicle-search">
            <i class="fa fa-search" aria-hidden="true"></i>
            <input #vehicleSearch id="cctv-search" type="search" class="form-control" aria-label="جستجوی خودرو"
              placeholder="نام خودرو یا آخرین تماس" [disabled]="listLoading" (input)="filter_list($event.target)">
          </div>
          <select id="cctv-command" class="form-select" formControlName="tiStatus" aria-label="فرمان گروهی"
            (change)="onCameraStatus($event.target.value)" [attr.disabled]="listLoading || !lst_Car.length ? '' : null">
            <option value="-1">انتخاب فرمان…</option>
            <ng-container *ngIf="!isLiveStreaming">
              <option value="0">روشن کردن همه</option>
              <option value="3">خاموش کردن همه</option>
              <option value="1">روشن کردن دوربین‌های وقایع</option>
              <option value="2">روشن کردن دوربین‌های کابین</option>
            </ng-container>
            <ng-container *ngIf="isLiveStreaming">
              <option value="3">خاموش کردن همه</option>
              <option value="4">خاموش کردن دوربین‌های وقایع</option>
              <option value="5">خاموش کردن دوربین‌های کابین</option>
            </ng-container>
          </select>
        </div>
        <div class="cars-container" [attr.aria-busy]="listLoading">
          <div *ngIf="listLoading" class="vehicle-state" role="status">
            <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i>
            <span>در حال دریافت خودروها…</span>
          </div>
          <div *ngIf="!listLoading && listError" class="vehicle-state vehicle-state--error" role="alert">
            <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
            <span>{{ listError }}</span>
            <button type="button" class="retry-button" (click)="vehicleSearch.value = ''; getAllCar(isLiveStreaming)">تلاش مجدد</button>
          </div>
          <div *ngIf="!listLoading && !listError && !lst_Car.length" class="vehicle-state" role="status">
            <i class="fa fa-search" aria-hidden="true"></i>
            <span>{{ vehicleSearch.value ? 'خودرویی با این مشخصات پیدا نشد.' : 'خودرویی برای نمایش وجود ندارد.' }}</span>
            <button *ngIf="vehicleSearch.value" type="button" class="retry-button"
              (click)="vehicleSearch.value = ''; filter_list(vehicleSearch)">پاک کردن جستجو</button>
          </div>
          <article *ngFor="let item of lst_Car; let i = index" class="vehicle-card"
            [class.vehicle-card--selected]="isChecked(item, 0) || isChecked(item, 1)">
            <div class="vehicle-card__heading">
              <span class="vehicle-avatar"><i class="fa fa-car" aria-hidden="true"></i></span>
              <div class="vehicle-identity">
                <h3 class="vehicle-name">
                  <span>{{ item.strFullName | faNum }}</span>
                </h3>
                <div class="vehicle-time" aria-label="آخرین تماس">
                  <i class="fa fa-clock-o" aria-hidden="true"></i>
                  <bdi>{{ item.strDate | faNum }} · {{ item.strTime | faNum }}</bdi>
                </div>
              </div>
              <span *ngIf="isItemWaiting(item)" class="spinner-border spinner-border-sm" role="status">
                <span class="visually-hidden">در حال دریافت تصویر</span>
              </span>
            </div>
            <div class="vehicle-cameras">
              <label class="vehicle-camera-option" [class.vehicle-camera--active]="isChecked(item, 0)" [for]="item.strUnitID + 'front'">
                <i class="fa fa-video-camera" aria-hidden="true"></i>
                <span>دوربین وقایع</span>
                <input type="checkbox" role="switch" [id]="item.strUnitID + 'front'"
                  [checked]="isChecked(item, 0)" (change)="selectRadio(item, 'front')">
              </label>
              <label class="vehicle-camera-option" [class.vehicle-camera--active]="isChecked(item, 1)" [for]="item.strUnitID + 'inside'">
                <i class="fa fa-user" aria-hidden="true"></i>
                <span>دوربین کابین</span>
                <input type="checkbox" role="switch" [id]="item.strUnitID + 'inside'"
                  [checked]="isChecked(item, 1)" (change)="selectRadio(item, 'inside')">
              </label>
            </div>
            <div class="vehicle-actions">
              <button type="button" class="vehicle-action vehicle-action--tonal" (click)="openCar(item)" title="مشاهده اطلاعات خودرو در صفحه جدید">
                <i class="fa fa-external-link" aria-hidden="true"></i>
                مشاهده خودرو
                <span class="visually-hidden">در صفحه جدید</span>
              </button>
              <button type="button" class="vehicle-action" (click)="updateTime($event, item, i)" title="به‌روزرسانی آخرین تماس">
                <i class="fa fa-refresh" aria-hidden="true"></i>
                به‌روزرسانی
              </button>
            </div>
          </article>
        </div>
      </div>
    </aside>
    <div class="col-xxl-9 col-md-8 col-12 p-1">
      <div class="w-100 h-100 border border-2 camera-panel">
        <div class="options-container" role="group" aria-label="چیدمان دوربین‌ها">
          <span class="options-label"><i class="fa fa-th-large" aria-hidden="true"></i> چیدمان نمایش</span>
          <div class="layout-actions">
            <button *ngFor="let item of templateActions" type="button" class="layout-button"
              [class.is-active]="item.view === iTemplateView" (click)="item.action()"
              [attr.aria-pressed]="item.view ? item.view === iTemplateView : null"
              [attr.aria-label]="item.label" [title]="item.label">
              <i *ngIf="!item.view" [class]="'fa ' + item.icon" aria-hidden="true"></i>
              <span *ngIf="item.view">{{ item.view | faNum }}</span>
            </button>
          </div>
        </div>
                <div id="cctvContainer" class="grid-container row gx-0 gy-0" [class.grid-container--two]="iTemplateView === 2">
                    <ng-container *ngFor="let i of repeat(iTemplateView); let idx = index">
                        <div [ngClass]="getColClass(iTemplateView)"
                            [style.max-height]="iTemplateView === 2 ? '50%' : 'calc(87vh / ' + getRowDiv(iTemplateView) + ')'">
                            <div class="w-100 h-100 camera-frame" [attr.aria-busy]="isCameraWaiting(idx)">
                                <ng-container *ngIf="shouldShowThumb(idx)">
                                    <img src="../../../assets/Img/video-thumb.png" [alt]="'دوربین' + (idx + 1)">
                                </ng-container>
                                <div *ngIf="isCameraWaiting(idx)" class="camera-waiting" role="status">
                                  <span class="spinner-border" aria-hidden="true"></span>
                                  <span>در انتظار تصویر دوربین…</span>
                                </div>
                                <ng-container *ngIf="checkedCameras[idx]?.strUnitId">
                                    <ng-container *ngIf="shouldShowVideo(idx)">
                                        <video-player 
                                            [tiChannel]="checkedCameras[idx].tiChannel"
                                            [src]="checkedCameras[idx].strUrl" 
                                            [obj_Cam]="checkedCameras[idx]">
                                        </video-player>
                                    </ng-container>

                                    <ng-container *ngIf="shouldShowStream(idx)">
                                        <stream-loader [obj_Camera]="checkedCameras[idx]"
                                            (updateChecked)="updateCheckedList($event)"
                                            (hideComponent)="failedRequest($event)">
                                        </stream-loader>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
        
  </section>

</main>
